import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getAuth, Auth } from 'firebase/auth';
import config from '../config';

// eslint-disable-next-line import/no-mutable-exports
let app: FirebaseApp | null = null;
let firestoreInstance: Firestore | null = null;
let authInstance: Auth | null = null;

/**
 * Initialize Firebase with the provided configuration
 */
const initializeFirebase = (): void => {
    if (app) return;

    const {
        apiKey, authDomain, projectId, storageBucket, messagingSenderId, appId,
    } = config.firebase.config;

    // Only initialize if we have the required config
    if (apiKey && projectId) {
        app = initializeApp({
            apiKey,
            authDomain,
            projectId,
            storageBucket,
            messagingSenderId,
            appId,
        });

        // Initialize Firestore with custom database ID if provided
        if (config.firebase.firestoreDbId) {
            firestoreInstance = getFirestore(app, config.firebase.firestoreDbId);
        } else {
            firestoreInstance = getFirestore(app);
        }

        authInstance = getAuth(app);
    }
};

// Initialize on module load
initializeFirebase();

export const firestore = firestoreInstance;
export const auth = authInstance;
export { app };
